import httpRequest, { ApiConfig } from 'httpRequest'
import {
    TerminalCashDrawerReportDetailContract,
    PosTerminalReportLookupContract,
    TerminalReportDetailContract,
} from 'models'
export interface SearchPosTerminalReportRequest {
    startDateTime?: string
    endDateTime?: string
    locations: string[]
    clients: string[]
    employees: string[]
}
const POS_TERMINAL_REPORT_PREFIX = '/location/pos-terminal-reports'
const POS_TERMINAL_REPORT_COMPANY_PREFIX = '/company/pos-terminal-reports'

const posTerminalReportService = {
    getTerminalReportById: (id: string, config?: ApiConfig) =>
        httpRequest.get<TerminalReportDetailContract>(
            POS_TERMINAL_REPORT_COMPANY_PREFIX + `/${id}`,
            config,
        ),
    getCurrentTerminalOpenedReport: (config?: ApiConfig) =>
        httpRequest.get<TerminalReportDetailContract>(
            POS_TERMINAL_REPORT_PREFIX + '/current-terminal/',
            config,
        ),
    getCurrentTerminalOpenedCashReport: (config?: ApiConfig) =>
        httpRequest.get<TerminalCashDrawerReportDetailContract>(
            POS_TERMINAL_REPORT_PREFIX + '/current-terminal/cashes',
            config,
        ),
    searchTerminalReports: (
        body?: SearchPosTerminalReportRequest,
        config?: ApiConfig,
    ) =>
        httpRequest.post<PosTerminalReportLookupContract[]>(
            POS_TERMINAL_REPORT_COMPANY_PREFIX + '/search',
            body,
            config,
        ),
}

export default posTerminalReportService
